import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summary", "form", "edit"]

  connect() {
    this.beforeCache = () => this.reset(false)
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }

  edit() {
    this.summaryTarget.hidden = true
    this.formTarget.hidden = false
    this.editTarget.hidden = true
    this.editTarget.setAttribute("aria-expanded", "true")
    this.formTarget.querySelector("input:not([type='hidden']), select")?.focus()
  }

  cancel() {
    this.reset(true)
  }

  reset(restoreFocus) {
    if (!this.hasFormTarget) return

    this.formTarget.reset()
    this.formTarget.querySelectorAll("input[type='password']").forEach(input => { input.value = "" })
    this.formTarget.querySelectorAll("[data-ruby-ui--form-field-target='error']").forEach(error => {
      error.textContent = ""
      error.classList.add("hidden")
    })
    this.formTarget.hidden = true
    this.summaryTarget.hidden = false
    this.editTarget.hidden = false
    this.editTarget.setAttribute("aria-expanded", "false")
    if (restoreFocus) this.editTarget.focus()
  }
}
